document.addEventListener('DOMContentLoaded', () => {
    // slick default setting
    let defaulsettings = {
        loop: true,
        speed: 700,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            nextEl: '.swiper-prev',
            prevEl: '.swiper-next'
        },
        autoplay: {
            delay: 5000,
            disableOnInteraction: false
        }
    };

    // start slider default
    let allSwipper =[];

    document.querySelectorAll('.swiper-slider').forEach((element,i) => {

        let swiperConfig = element.dataset.swiper ? JSON.parse(element.dataset.swiper) : defaulsettings;
        element.setAttribute(`data-swiper-${i}`,"");
        let swiper = new Swiper(`[data-swiper-${i}]`, swiperConfig);
        allSwipper[i] = swiper;

    });

    /////// Slider reviews  //////////
	let quadReviews = new Swiper('.reviews__slider',{
		loop: true,
		speed: 700,
		effect: 'fade',
		fadeEffect: {
			crossFade: true
		},
		navigation: {
			prevEl: '.reviews-prev',
			nextEl: '.reviews-next'
		}
	});

    //////  Slider Slide /////

    let quadSlider = new Swiper('.slider__slider',{
        loop: true,
        speed: 700,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            prevEl: '.slider-prev',
            nextEl: '.slider-next'
        }
    });

    /////// Slider Card ///// 

    let quadcardsBlock = new Swiper('.cards-block__slider',{
        slidesPerView: 1,
        spaceBetween: 30,
        loop: true,
        speed: 700,
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            prevEl: '.cards-block-prev',
            nextEl: '.cards-block-next'
        },
        breakpoints: {
          640: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 50,
          },
        },
    });


    //////  Slider Gallery /////////////
    let quadGallery = new Swiper('.gallery-quad__slider',{
        speed: 700,
        centeredSlides: true,
        loop: true,
        slidesPerView: 1.2,
        spaceBetween: 10,
        navigation: {
            prevEl: `.gallery-quad-prev`,
            nextEl: `.gallery-quad-next`
        },
        breakpoints: {
            700: {
                slidesPerView: 2,
                spaceBetween: 15
            }
        },
        on: {
            slideChange: function () {
                if (document.querySelector('.js-gallery-description')) {
                    activeContent && activeContent.classList.remove("active");
                    activeContent = document.querySelector('.js-gallery-description').children[this.realIndex];
                    activeContent.classList.add('active');
                }
            }
        }
    });


});